import React, { useState } from "react";
import {
  SearchWrapper,
  SearchInputField,
  IconWrapper,
  ClearIconWrapper,
  SearchFieldLabel,
} from "./SearchInput.styles";
import { SearchInputProps } from "./SearchInput.types";
import { Body5RegularTypography } from "../../primitives/Typography/typographyVariants";
import { colorGuide } from "../../theme/colors";
import { Icon } from "../Icon/Icon";

export const SearchInput: React.FC<SearchInputProps> = ({
  value = "",
  showClearButton = true,
  onChange,
  onBlur,
  label = "",
  onClick,
  onClickClearIcon,
  dataCy,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    onChange && onChange({ ...e, target: { ...e.target, value: newValue } });
  };

  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  return (
    <SearchWrapper isFocused={isFocused} hasValue={!!value} onClick={onClick}>
      <IconWrapper>
        <Icon
          name="fa-solid fa-magnifying-glass"
          color={
            isFocused
              ? colorGuide.lightComponents.searchInput.focused.iconColor
              : colorGuide.lightComponents.searchInput.iconColor
          }
          height="16"
          width="16"
          size="14"
        />
      </IconWrapper>
      {label && !value && !isFocused && (
        <SearchFieldLabel htmlFor={label}>
          <Body5RegularTypography>{label}</Body5RegularTypography>
        </SearchFieldLabel>
      )}
      <SearchInputField
        type="text"
        value={value}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        data-cy={dataCy}
      />
      {showClearButton && (isFocused || value) && (
        <ClearIconWrapper onClick={onClickClearIcon}>
          <Icon
            name="fa-solid fa-xmark"
            color={colorGuide.lightComponents.searchInput.iconColor}
            size="14"
            height="16"
            width="16"
          />
        </ClearIconWrapper>
      )}
    </SearchWrapper>
  );
};

export default SearchInput;
